import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

/**
 * CTAButton — reusable pill button with icon + label.
 *
 * @param {Object} props
 * @param {string} props.iconClass - The ddc-icon class for the button icon
 * @param {string} props.label - The button label text
 * @param {string} props.testId - The data-testid for the button
 * @returns {React.ReactElement}
 */
const CTAButton = ({ iconClass, label, testId }) => (
	<button
		type="button"
		className="btn btn-default ws-nav-drawer__cta-btn d-flex justify-content-center align-items-center"
		data-testid={testId}
	>
		<span
			className={setClassNames(['ddc-icon', iconClass])}
			aria-hidden="true"
			data-testid={`${testId}-icon`}
		/>
		{label}
	</button>
);

CTAButton.propTypes = {
	iconClass: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	testId: PropTypes.string.isRequired
};

export default CTAButton;
